export const extractArrayPayload = (result: any): any[] | null => {
  if (Array.isArray(result)) {
    return result;
  }
  if (!result || typeof result !== "object") {
    return null;
  }

  const candidates = [result.data, result.items, result.value, result.results, result.$values];
  for (const candidate of candidates) {
    if (Array.isArray(candidate)) {
      return candidate;
    }
  }
  return null;
};

export const getApiErrorMessage = (
  error: any,
  fallback = "Unable to complete the request. Please try again."
): string => {
  if (error == null || error === "") {
    return fallback;
  }

  if (typeof error === "string") {
    const trimmed = error.trim();
    if (!trimmed) {
      return fallback;
    }
    if (/unexpected token|json\.parse|failed to fetch|networkerror|is not a function/i.test(trimmed)) {
      return fallback;
    }
    if (/^not found$/i.test(trimmed) || /^request failed \(404/i.test(trimmed)) {
      return "No data found";
    }
    return trimmed;
  }

  if (error instanceof Error) {
    return getApiErrorMessage(error.message, fallback);
  }

  const parts = [
    error.message,
    error.exceptionMessage,
    error.error_description,
    error.error,
    error.title,
    error.detail,
  ].filter((part) => typeof part === "string" && part.trim());

  const uniqueParts = parts
    .map((part: string) => part.trim())
    .filter((part, index, arr) => arr.indexOf(part) === index);
  if (uniqueParts.length > 0) {
    return uniqueParts.join(" - ");
  }

  return fallback;
};
